﻿export default {
    editor: {
        back_to_list: "Volver a la lista",
        new_episode: "Nuevo Episodio",
        untitled_episode: "Episodio sin título",
        edit: "Editar",
        delete: "Eliminar",
        webtoon_editor: "Editor de Webtoon",
        episode_prefix: "Episodio",
        preview: "Vista previa",
        live_preview: "Vista previa en vivo",
        preview_hint: "Verifique la vista previa",
        input_title_placeholder: "Ingrese el título del episodio",
        display_mode: "Modo de visualización",
        mode_webtoon: "Desplazamiento vertical (Webtoon)",
        mode_comic: "Vista horizontal (Cómics)",
        mode_insta: "InstaToon",
        mode_desc: "El modo de vista previa cambia según la selección.",
        thumbnail: "Miniatura",
        upload_image: "Subir imagen",
        bgm: "Música de fondo (BGM)",
        manuscript_images: "Imágenes del manuscrito",
        drag_drop_hint: "Arrastre y suelte imágenes o haga clic para subir.",
        save: "Guardar",
        save_draft: "Guardar borrador",
        save_changes: "Guardar cambios",
        publish: "Publicar",
        publish_now: "Publicar ahora",
        set_draft: "Cambiar a borrador",
        publish_settings: "Configuración de publicación",
        saving: "Guardando...",
        saved: "Guardado",
        processing: "Procesando...",
        publish_confirm: "¿Desea publicar?",
        publish_complete: "Publicación completa.",
        publish_success: "Publicado exitosamente.",
        published: "Publicado",
        published_start_ai: "Publicación iniciada. Ejecutando análisis de IA.",
        save_complete: "Guardado completo",
        save_required: "Se requiere guardar",
        upload_complete: "Carga completa",
        upload_fail: "Fallo en la carga: ",
        upload_fail_desc: "La carga de la imagen falló.",
        draft_mode_title: "Modo borrador",
        draft_mode_private_desc: "Este episodio es privado.",
        draft_mode_switched: "Cambiado a modo borrador.",
        image_mode_mismatch: "No coincide el modo de imagen ({mode})",
        invalid_format: "Formato inválido.",
        mode_change_blocked_desc: "No se puede cambiar el modo ya que existen imágenes. ({mode})",
        mode_change_blocked: "No se puede cambiar el modo",
        tap_nav_hint: "Toque izquierda/derecha para navegar",
        ai_analyze_admin: "Análisis de IA (Admin)",
        ai_analyze_local: "Análisis de contexto de IA",
        ai_analyze_confirm: "¿Iniciar análisis de IA?",
        ai_confirm: "Confirmación de IA",
        ai_context_analysis_confirm: "¿Ejecutar análisis de contexto? (Advertencia: Sobrescribe datos existentes)",
        ai_analyze_title: "Análisis de IA",
        ai_requesting: "Solicitando análisis de IA...",
        ai_analyzing: "Analizando...",
        ai_analyzing_background: "Iniciando análisis de IA en segundo plano...",
        ai_processing_title: "Procesando",
        ai_no_items: "No hay elementos para analizar.\n{log}",
        ai_no_items_found: "No se encontraron elementos para el an찼lisis.",
        diagnosis_report: "Informe de diagn처stico",
        ocr_complete: "An찼lisis OCR completo ({n} elementos)",
        seo_trigger: "Generaci처n de datos SEO programada.",
        ai_complete_desc: "An찼lisis de IA completo.",
        ai_error: "Error de an찼lisis de IA",
        ai_fail_msg: "Fallo en el an찼lisis de IA: {e}",

        // Novel Studio & Legacy Keys
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        complete: "Completado",
        pending_approval: "Pendiente de Aprobaci처n",
        approval_requested: "Aprobaci처n Solicitada",
        approval_desc: "Su obra ha sido enviada para su aprobaci처n.\\nSer찼 publicada despu챕s de la revisi처n del administrador.",
        error: "Error",
        ai_analyze_btn: "An찼lisis IA",
        series_info: "Info de Serie (Upload)",

        novel_editor: "Editor de Novela",
        auto_saved: "Guardado Automático",
        untitled_chapter: "Sin Título",
        chapter_title_placeholder: "Título del Capítulo",
        delete_title: "Eliminar Capítulo",
        save_button: "Guardar",
        novel_info: "Información de Novela",
        novel_title: "Título de Novela",
        tags_placeholder: "Romance, Fantasía",
        chapter_list: "Lista de Capítulos",
        chapter_count: "Total {n} Episodios",
        add_empty_chapter: "Añadir Capítulo Vacío",

        public_toggle: "Público",
        private_toggle: "Privado",
        bgm_suno_label: "BGM Settings",
        txt_upload: "Subir TXT",
        content_placeholder: "Introducir contenido...",
        note_placeholder: "Nota del autor...",
        ai_analysis_complete: "An찼lisis IA Completo",
        recommend_keywords: "Palabras Clave",
        hook: "Gancho",
        analysis_saved: "Datos guardados.",
        analysis_fail: "Fallo de an찼lisis.",
        analysis_short: "Contenido muy corto.",
        age_all: "Todos",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Rating",
        age_19_desc: "Bloquea a menores.",

        select_chapter: "Selecciona un cap챠tulo",
        episode_placeholder: "ej) Ep. 1",
        bgm_placeholder: "URL de Suno AI...",
        cover_upload_fail: "Fallo al subir portada: ",
        ai_analysis_fail: "Fallo en an찼lisis IA: ",
        save_fail: "Fallo al guardar: ",

        // Extras

    },
    auth: {
        attendance_success: "📅 ¡Asistencia completada! (Daily Rewards)\n¡Bono de hoy +50 puntos entregado!",
        signup_bonus: "🎉 ¡Registro exitoso! 🎊\n¡Bono de bienvenida +100 puntos entregado!",
        referral_bonus: "🤝 ¡Registro por invitación completado! 🎁\nBono de bienvenida 100P + Bono de recomendación 500P\n¡Total 600 puntos entregados!",
        login_required: "Inicio de sesión requerido"
    },
    social: {
        subscribe_on: "Añadido a la lista de suscripción.",
        subscribe_off: "Suscripción cancelada.",
        like_on: "¡Me gusta!",
        like_off: "Me gusta cancelado.",
        follow_on: "Siguiendo.",
        follow_off: "Dejar de seguir."
    },
    comment: {
        submit_success: "Comentario publicado.",
        delete_confirm: "쩔Realmente quieres eliminar esto?",
        delete_success: "Eliminado.",
        delete_error: "Error al eliminar",
        submit_error: "Error al publicar comentario",
        empty_error: "Por favor ingrese contenido."
    },
    payment: {
        verify_success: "징Verificaci처n completa!\n{amount} Estrellas acreditadas.",
        verify_fail: "Verificaci처n fallida",
        user_cancel: "Pago cancelado.",
        error: "Error de pago"
    },
    common: {
        confirm: "Confirmar",
        cancel: "Cancelar",
        close: "Cerrar",
        save: "Guardar",
        delete: "Eliminar",
        edit: "Editar",
        copy: "Copiar",
        loading: "Cargando...",
        error: "Ocurri처 un error.",
        success: "횋xito.",
        webtoon: "Webtoon",
        webnovel: "Novela Web",
        cinenovel: "Cine-Novela",
        published: "Publicado",
        draft: "Borrador",
        editor: "Editor"
    },
    seo: {
        default_title: "Mirinae Platform - Where Imagination Becomes Reality",
        default_desc: "Next-gen Webtoon/Webnovel platform combining AI and Art. Become an author and create your own universe."
    },
    footer: {
        terms: "T챕rminos de Servicio",
        privacy: "Pol챠tica de Privacidad",
        report: "Reportar Infracci처n",
        biz_ceo: "CEO",
        biz_addr: "Direcci처n",
        biz_tel: "Soporte",
        biz_email: "Email",
        biz_license: "Licencia",
        biz_mail_order: "Comercio Electr처nico",
        biz_none: "Informaci처n no registrada",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    menu: {
        home: "Inicio",
        webtoon: "Webtoon",
        webnovel: "Novela Web",
        novel: "Novela Web",
        davinci: "DaVinci",
        studio: "Estudio Creativo",
        library: "Biblioteca",
        support: "Apoyo",
        admin: "P찼gina de Admin",
        config: "Enlaces Externos",
        factory: "Popups y Avisos",
        docs: "Editor de Docs",
        analytics: "An찼lisis de Tendencias",
        plaza: "Club Ssulwha",
        wisdom: "Sabidur챠a de Estrellas",
        recommendation: "Estante Vac챠o",
        charge: "Estaci처n Estelar", // Added
        guide: "Gu챠a de Usuario",
        "whats-new": "Novedades",
        invite: "Invitar Amigos",
        about: "Sobre el Servicio",
        terms: "T챕rminos de Servicio",
        privacy: "Pol챠tica de Privacidad",
        report: "Centro de Reportes",
        "app-setting": "Ajustes de App",
        login: "Iniciar Sesi처n / Registrarse",
        logout: "Cerrar Sesi처n",
        MyPage: "Mi P찼gina",
        notice: "Avisos",
        proposal: "Sugerencias",
        settings: "Ajustes",
        language: "Idioma"
    },
    modal: {
        translate_title: "Seleccionar Idioma",
        translate_placeholder: "Seleccione el idioma para traducir.",
        translate_start: "Traducir"
    },
    msg: {
        welcome_beta: "Bienvenido al servicio beta de Mirinae Platform.",
        login_required: "Inicia sesi처n para descubrir m찼s historias.",
        login_btn: "Iniciar Sesi처n / Registrarse"
    },
    profile: {
        follow: "Seguir",
        following: "Siguiendo",
        mypage: "Mi P찼gina",
        followers: "Seguidores",
        following_count: "Siguiendo",
        bio_empty: "Sin presentaci처n.",
        works: "Obras",
        feed: "Feed",
        guestbook: "Libro de Visitas",
        works_empty: "No hay obras registradas.",
        works_error: "Error al cargar obras",
        feed_empty: "No hay publicaciones.",
        feed_error: "Error al cargar feed.",
        feed_error_detail: "Creaci처n de 챠ndice en progreso o error de red.",
        follow_error: "Error al seguir."
    },
    support: {
        title: "Centro de Soporte 1:1",
        input_placeholder: "Ingrese su consulta...",
        empty_state_title: "No hay historial de consultas.",
        empty_state_desc: "징Preg첬ntenos lo que sea en cualquier momento!",
        status_received: " ??Recibido",
        auto_reply: "Su consulta ha sido recibida. Responderemos secuencialmente. Mientras tanto, disfrute de Ssulwha World.",
        send_fail: "Error al enviar mensaje"
    },
    author: {
        apply_title: "Solicitud de Autor",
        apply_desc: "Comparte tu historia con el mundo. Deja una breve introducci처n y portafolio, y te contactaremos despu챕s de la revisi처n.",
        email_label: "Correo electr처nico",
        email_placeholder: "Ingrese correo de contacto",
        email_hint: "Podemos contactarlo sobre resultados de aprobaci처n y contratos.",
        intro_label: "Introducci처n",
        intro_placeholder: "Por favor pres챕ntese (Experiencia de escritura, estilo, etc.)",
        portfolio_label: "Portafolio (Opcional)",
        submit_btn: "Aplicar",
        email_required: "Por favor ingrese su correo electr처nico.",
        intro_required: "Por favor ingrese su introducci처n.",
        submitting: "Enviando...",
        submit_success: "Solicitud de autor enviada."
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (??price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },
    history: {
        empty: {
            title: "No history yet.",
            desc: "Shall we explore some works?",
            action_btn: "Go Explore"
        },
        common: {
            no_title: "No Title"
        },
        last_viewed: "Last viewed:",
        episode_fmt: "Ep. {n}",
        delete_confirm: {
            msg: "Do you want to delete this history?",
            title: "Delete History"
        }
    },
    library: {
        empty_title: "La biblioteca est찼 vac챠a",
        empty_desc: "Las obras compradas o vistas aparecer찼n aqu챠.",
        explore_btn: "Explorar Obras",
        select_hint: "Seleccione una obra para ver la lista.",
        total_episodes: "Total {n} episodios"
    },
    badge: {
        best_reviewer: "Mejor Rese챰ador",
        top_author: "Autor Top",
        vip: "VIP",
        donation_king: "Rey de Donaci처n",
        hall_of_fame: "Sal처n de la Fama"
    },
    tab: {
        works: "Obras",
        feed: "Ssulwha (Feed)",
        guestbook: "Libro de Visitas"
    },
    tag: {
        fantasy: "Fantas챠a",
        romance: "Romance",
        martial_arts: "Artes Marciales",
        drama: "Drama",
        slice_of_life: "Recuentos de la vida",
        comedy: "Comedia",
        thriller: "Suspenso",
        school: "Escolar",
        munchkin: "OP (Overpowered)",
        regression: "Regresi처n",
        possession: "Posesi처n",
        system: "Sistema",
        growth: "Crecimiento",
        revenge: "Venganza",
        heart: "Coraz처n",
        horror: "Terror",
        sport: "Deportes",
        history: "Historia Alt."
    },
    guestbook: {
        title: "Libro de Visitas",
        input_placeholder: "징Deja un mensaje de apoyo!",
        secret: "Secreto",
        submit: "Publicar",
        empty: "징S챕 el primero en dejar un mensaje! ?몿",
        secret_content: "Este es un mensaje secreto.",
        delete_confirm: "쩔Est찼s seguro de eliminar?",
        reply: "Responder",
        reply_placeholder: "Escribir respuesta...",
        reply_delete_confirm: "쩔Eliminar respuesta?",
        confirm_delete_reply: "쩔Eliminar esta respuesta?",
        submit_error: "Error al enviar: ",
        emoji_error: "Error al cargar emojis"
    },
    pwa: {
        install_title: "Instalar App",
        install_desc: "Disfruta de una experiencia más rápida.",
        install_btn: "Instalar",
        later_btn: "Más tarde",
        ios_guide_title: "Instalar en iPhone",
        ios_guide_desc: "Disfruta la mejor experiencia en pantalla completa.",
        ios_step1: "Toca el botón compartir",
        ios_step2: "Elige 'Añadir a Inicio'",
        update_title: "¡Nueva versión ({version})!",
        update_title_v2: "¡Una nueva versión está disponible!",
        update_desc: "Actualiza para nuevas funciones.",
        update_btn: "Actualizar",
        updating: "Actualizando...",
        offline_title: "Estás sin conexión",
        offline_desc: "Por favor revisa tu internet.",
        copy_success: "Copiado al portapapeles",
        copy_fail: "Fallo al copiar"
    },
    settings: {
        title: "Ajustes de App",
        general: "General",
        push_title: "Notificaciones Push",
        push_desc: "Recibir notificaciones de actualizaciones",
        app_info: "Información de App",
        current_version: "Versión Actual",
        danger_zone: "Zona de Peligro",
        delete_account_title: "Eliminar Cuenta (Volver a la Realidad)",
        delete_account_desc: "Todos los datos serán eliminados y no se podrán recuperar.",
        delete_account_button: "Volver a la Realidad"
    },
    proposal: {
        title: "Sabidur챠a de Estrellas",
        desc: "Tu brillante sabidur챠a expande el universo.",
        label_title: "T챠tulo de Propuesta",
        placeholder_title: "Ingresa el n첬cleo de tu idea",
        label_content: "Detalles",
        placeholder_content: "Si챕ntete libre de compartir tus ideas. 징Cuanto m찼s espec챠fico, mejor!",
        btn_submit: "Enviar Sabidur챠a",
        success_title: "Sabidur챠a Recibida",
        success_desc: "La sabidur챠a de {name} ha sido recibida.<br>Gracias por tu valioso aporte."
    },
    report: {
        title: "Centro de Reportes",
        category_label: "CATEGORY",
        content_label: "CONTENT",
        url_label: "RELATED URL",
        categories: {
            general: "Consulta General / Otros",
            spam: "Spam / Promoci처n Inapropiada",
            abuse: "Lenguaje Abusivo / Discurso de Odio",
            adult: "Contenido Adulto / Nocivo para Menores",
            bug: "Bug del Sistema / Error"
        },
        placeholder_content: "Por favor describe el problema en detalle.",
        btn_submit: "Enviar Reporte",
        warning: "Los reportes falsos pueden resultar en restricciones del servicio.",
        success_title: "Reporte Enviado",
        success_desc: "Revisaremos y tomaremos medidas r찼pidamente.<br>Gracias por su valiosa informaci처n.",
        login_required: "Debe iniciar sesi처n para denunciar.",
        submit_success: "Denuncia enviada exitosamente.\nPor favor verifique en el centro de administraci처n...",
        error: "Error al enviar denuncia",
        modal: {
            title: "Denunciar",
            desc: "Por favor seleccione un motivo. Las denuncias falsas pueden resultar en sanciones.",
            category: "Categor챠a",
            detail: "Detalle",
            url: "URL Relacionada",
            submit: "Enviar",
            cancel: "Cancelar"
        },
        reason: {
            spam: "Spam / Promoci처n",
            abusive: "Lenguaje Abusivo",
            inappropriate: "Contenido Inapropiado",
            other: "Otro / Consulta"
        }
    },
    guide: {
        title: "Ajuste del Sistema",
        desc: "Estamos ajustando finamente la br첬jula<br>para ayudar en tu viaje.",
        wait: "Espera un momento, por favor."
    },
    recommendation: { // Added entire block since it was missing in es.js
        loading_title: "Leyendo tu trayectoria...",
        loading_desc: "Conectando tus huellas pasadas y las estrellas donde te quedaste",
        fallback_title: "La constelaci처n de <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span><br>a첬n es tenue.",
        fallback_desc: "Pero no te preocupes.<br>Hemos seleccionado algunas historias brillantes que han iluminado las noches de muchos otros.<br><span class=\"text-sm opacity-70 mt-1 block\">A medida que se acumulen tus huellas, encontraremos una 처rbita solo para ti.</span>",
        personal_title: "Estanter챠a de <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>,<br>La historia que se colocar찼 a continuaci처n",
        personal_desc: "Encontramos 5 estrellas que resuenan con tu gusto.",
        label_empty_shelf: "Estante Vac챠o (The Empty Shelf)",
        btn_refresh: "Obtener otras recomendaciones",
        error_title: "Conexi처n Inestable",
        btn_retry: "Reintentar",
        empty_data_title: "A첬n no hay suficientes datos",
        btn_browse: "Explorar Obras",
        // Widget Specific
        widget_title: "쩔Buscas tu<br>pr처xima historia?",
        widget_desc: "Basado en los gustos de {name}, seleccionamos 5 obras.",
        widget_desc_guest: "Basado en tus gustos, seleccionamos 5 obras.",
        btn_check: "Ver Recomendaci처n"
    },
    star_station: {
        title: "Estaci처n Estelar",
        subtitle: "Disfruta las obras con m찼s libertad.",
        my_stars: "Mis Estrellas",
        history_tab: "Historial",
        products_tab: "Productos",
        payment_method: "M챕todo de Pago",
        btn_charge: "Recargar",
        history_empty: "No hay historial de recargas.",
        product_names: {
            stardust: "Polvo de Estrellas",
            shooting_star: "Estrella Fugaz",
            little_bear: "Osa Menor",
            silver_river: "R챠o de Plata",
            galaxy_master: "Maestro Gal찼ctico",
            star_maker: "Creador de Estrellas"
        }
    },
    studio: {
        title: "Estudio Creativo",
        open_menu: "Abrir Men첬",
        exit: "Salir",
        new_series: "Nueva Serie",
        lab_badge: "LAB",
        lab_title: "Laboratorio DaVinci",
        lab_desc: "Experimenta un nuevo mundo de creaci처n con IA.",
        total_views: "Vistas Totales",
        total_likes: "Me Gusta Totales",
        total_followers: "Seguidores",
        weekly_performance: "Rendimiento Semanal",
        views_trend_7d: "Tendencia de vistas (7 d챠as)",
        live_data: "En Vivo",
        my_series_list: "Mis Series",
        total_series_count: "Total {n} Series",
        empty_series_title: "Comienza una nueva historia",
        empty_series_desc: "Despliega tu imaginaci처n al mundo.",
        btn_editor: "Editor",
        btn_settings: "Ajustes",
        btn_delete: "Eliminar",
        delete_modal_title: "Eliminar Serie",
        create_first_episode: "징Crea tu primer episodio!",
        create_first_episode_desc: "Haz clic en el bot처n Nuevo Episodio para comenzar.",
        last_updated: "횣ltima actualizaci처n: {date}",
        delete_episode_title: "Eliminar Episodio",
        delete_episode_content: "쩔Est찼s seguro de que quieres eliminar el episodio '{title}'?",

        // Toolbar
        bold: "Negrita",
        italic: "Cursiva",
        highlight_red: "Resaltar (Rojo)",
        highlight_blue: "Resaltar (Azul)",
        save_preserve_status: "Guardar (Mantener Estado)",
        delete_modal_content: "쩔Est찼s seguro de que deseas eliminar '{title}'? Esta acci처n no se puede deshacer."
    },

    rating_guide: {
        title: "Gu챠a de Clasificaci처n de Contenido",
        all_title: "Todas las Edades",
        all_desc: "Contenido adecuado para todas las edades.<br>Sin o muy poca violencia, contenido sexual o lenguaje inapropiado.",
        title_12: "12+ (Adolescentes)",
        desc_12: "Puede contener violencia leve, malas palabras o terror.<br>Se sugiere supervisi처n parental para menores de 12 a챰os.",
        title_15: "15+ (J처venes Adultos)",
        desc_15: "Puede contener violencia moderada, lenguaje fuerte o temas maduros.<br>Puede retratar comportamiento criminal o tab첬es sociales.",
        title_19: "19+ (Solo Adultos)",
        desc_19: "Contiene contenido sexual expl챠cito, violencia extrema o lenguaje abusivo.<br><strong class='text-red-500'>Legalmente restringido a adultos 19+. Se requiere verificaci처n de identidad.</strong>",
        disclaimer: "* La clasificaci처n es responsabilidad del autor. Las clasificaciones falsas pueden llevar a cambios forzados o sanciones.",
        confirm: "Entendido"
    },
    placeholder: {
        search: "Buscar obras, autores, etiquetas...",
        comment: "Escribir comentario...",
        guest_book: "징Deja un mensaje de apoyo!",
        title_required: "Por favor ingresa un t챠tulo.",
        content_required: "Por favor ingresa contenido."
    },
    toast: {
        login_success: "Inicio de sesi처n exitoso.",
        copy_success: "Copiado al portapapeles.",
        network_error: "Error de red.",
        processing: "Procesando..."
    },
    viewer: {
        settings_title: "Ajustes de Audio/Scroll",
        bgm_volume: "Volumen BGM",
        bgm_off: "Sin BGM",
        auto_speed: "Velocidad Auto-Play",
        settings_btn: "Ajustes",
        translate_btn: "Traducir IA",
        tts_btn: "Leer en voz alta (TTS)",
        bgm_btn: "BGM",
        top_btn: "Arriba",
        auto_play: "Auto Slide",
        auto_scroll: "Auto Scroll",
        start_auto: "Auto-Play Iniciado",
        stop_auto: "Auto-Play Detenido",
        tts_warn: "Nota: TTS reproduce en el idioma original (Coreano)."
    },
    login: {
        subtitle: "Donde tu imaginaci처n se hace realidad",
        btn_google: "Continuar con Google",
        or: "O",
        label_email: "Email",
        label_password: "Contrase챰a",
        btn_email_login: "Iniciar sesi처n con Email",
        btn_email_signup: "Registrarse con Email",
        msg_no_account: "쩔No tienes cuenta?",
        msg_has_account: "쩔Ya tienes cuenta?",
        btn_signup: "Registrarse",
        btn_login: "Iniciar sesi처n",
        msg_processing: "Procesando...",
        msg_email_sent: "Email de verificaci처n enviado. Por favor revise e inicie sesi처n.",
        err_invalid_auth: "Email o contrase챰a inv찼lidos.",
        err_email_in_use: "Email ya en uso.",
        err_default: "Ocurri처 un error."
    },
    terms: {
        title: "Control de Inmigraci처n",
        desc: "Bienvenido a Ssulwha World.<br>Por favor acepta los t챕rminos para continuar.",
        required: "[Requerido]",
        optional: "[Opcional]",
        label_terms: "T챕rminos de Servicio",
        label_privacy: "Pol챠tica de Privacidad",
        label_marketing: "Consentimiento de Marketing",
        btn_start: "Empezar",
        btn_processing: "Procesando..."
    },
    plaza: {
        title: "CLUB SSULWHA",
        subtitle: "Espacio de comunicaci처n emocional para la Gen Z, Club Ssulwha",
        btn_sync: "??Sincronizar conteo de comentarios (Solo Admin)",
        composer_placeholder_init: "쩔Qu챕 historia te gustar챠a lanzar a este universo?",
        composer_placeholder_thread: "Escribe la historia continua...",
        composer_placeholder_quote: "Deja tus pensamientos sobre esta historia...",
        btn_add_thread: "A챰adir Hilo",
        btn_submit: "Lanzar Estrella",
        btn_submit_quote: "Citar",
        btn_submitting: "Subiendo...",
        quote_suffix: " Citado"
    },
    main: {
        banner_welcome: "??징Explora el divertido Mundo Ssulwha!",
        search_placeholder: "Buscar obras, autores, etiquetas...",
        hall_of_fame: "Sal처n de la Fama (Weekly Best)",
        hall_of_fame_locked: "El Sal처n de la Fama es solo para miembros",
        hall_of_fame_desc: "쩔Qui챕n es el usuario m찼s activo esta semana? 징Inicia sesi처n para ver el ranking en tiempo real!",
        login_btn: "Ir a Iniciar Sesi처n",
        todays_pick: "Selecci처n de Hoy",
        continue_reading: "Continuar Leyendo",
        trending: "Tendencias Ahora",
        new_arrivals: "Nuevas Llegadas",
        all_works: "Todas las Obras",
        tag_cloud: "Explorar por Etiquetas",
        filter_all: "Todo",
        filter_webtoon: "Webtoon",
        filter_webnovel: "Novela Web",
        realtime_club: "Club Ssulwha en Tiempo Real",
        enter_club: "Entrar al Club",
        be_the_first: "징S챕 el primero en lanzar una estrella!",
        go_to_plaza: "Ir a la Plaza",
        search_results: "Resultados para '{query}'",
        search_no_results: "No se encontraron resultados.",
        search_try_other: "Intenta buscar con otras palabras clave.",
        splash_loading: "Entrando al Mundo Ssulwha..."
    },
    mypage: {
        tab_library: "Biblioteca",
        tab_history: "Historial",
        tab_activity: "Actividad",
        tab_likes: "Me Gusta",
        tab_wallet: "Billetera",
        tab_settings: "Ajustes",
        no_activity: "A첬n no hay actividad.",
        go_to_plaza: "Ir a la Plaza",
        followers: "Seguidores",
        following: "Siguiendo",
        edit_profile_tooltip: "Editar Perfil",
        role_author: "Autor",
        role_reader: "Lector",
        role_admin: "Admin",
        author_pending: "??Aprobaci처n Pendiente",
        btn_studio: "Estudio de Creador",
        btn_apply_author: "Aplicar como Autor",
        default_bio: "Por favor ingrese una breve biograf챠a.",
        menu_edit_profile: "Editar Perfil",
        menu_public_profile: "Ver Perfil P첬blico",
        current_version: "Versi처n Actual",
        invite_title: "Invitar Amigos",
        invite_reward: "Recompensa +500P",
        invite_desc: "Comparte tu enlace. 징T첬 y tu amigo reciben 500P!",
        invited_count: "Amigos Invitados",
        unit_people: "personas",
        edit_profile_title: "Editar Perfil",
        label_photo: "Foto de Perfil",
        btn_upload: "Subir",
        btn_random: "Aleatorio",
        placeholder_photo_url: "O ingresar URL de imagen",
        label_nickname: "Apodo",
        label_bio: "Biograf챠a",
        placeholder_bio: "Expr챕sate en una l챠nea."
    },
    davinci: {
        episode_settings: "Ajustes de Episodio",
        title: "T챠tulo",
        thumbnail: "Miniatura",
        bgm: "BGM",
        add_block: "A챰adir Bloque",
        text_block: "Texto",
        image_block: "Imagen",
        upload_image: "Subir Imagen",
        upload_thumb: "Subir Miniatura",
        upload_success: "Subida Exitosa",
        bgm_placeholder: "URL Suno o Enlace MP3",
        tip: "Tip:",
        drag_tip: "Arrastra para reordenar bloques.",

        // DaVinci Settings
        project_settings: "Ajustes de Proyecto",
        isbn: "ISBN (Opcional)",
        uci: "UCI (Identificador)",
        is_adult: "Solo Adultos (19+)",
        is_ai: "Contenido Generado por IA",
        bgm_url_label: "BGM (Enlace Suno o URL MP3)",
        suno_tip: "* Los enlaces de Suno se convierten autom찼ticamente.",
        author_note: "Nota del Autor",
        save_settings: "Guardar Ajustes",
        cover_upload: "Subir Portada",

        // DaVinci List
        episode_management: "Gesti처n de Episodios",
        create_new_episode: "A챰adir Nuevo Episodio",
        new_episode_title_prompt: "T챠tulo del Nuevo Episodio:",
        create_fail: "Fallo en Creaci처n",
        no_episodes: "No se encontraron episodios.",
        published_badge: "Publicado",
        draft_badge: "Borrador",
        edit_btn: "Editar",

        // DaVinci Toolbox
        recommend_size: "Recomendado: 16:9",
        thumbnail_uploading: "Subiendo miniatura...",
        thumbnail_applied: "Miniatura aplicada",
        guide: {
            title: "Gu챠a de Botones",
            save: "Guardar",
            save_desc: "Guarda los cambios.",
            draft: "Borrador",
            draft_desc: "Cambiar a privado.",
            publish: "Publicar",
            publish_desc: "Hacer p첬blico. (Visible para lectores)",
            auto_save: "Autoguardado",
            auto_save_on: "ON (3s)",
            auto_save_desc: "Guarda autom찼ticamente cada 3 segundos."
        },
        upload_fail: "Fallo en subida: ",
        save_draft: "Guardar Borrador",
        publish: "Publicar",
        saving: "Guardando...",
        published: "징Publicado! Disponible para lectores.",
        publish_confirm: "쩔Publicar ahora? Los lectores podr찼n verlo.",
        preview_preparing: "Preparando vista previa..."
    },
    intro: {
        slogan: "Creatividad Humana, Escalabilidad de la IA",
        hero_title: "El Pez de Babel",
        hero_subtitle: "para Cine-Novelas.",
        status_active: "Motor de Traducción Activo",
        status_cine: "Formato Cine-Novela",
        desc_1: "Lee IPs coreanas al instante en <span class='text-white font-bold mx-1'>10 idiomas</span> con nuestro motor de IA no destructivo.",
        desc_2: "Experimenta el <span class='text-white font-bold mx-1'>Primer Formato Híbrido del Mundo</span> donde visuales y novelas se fusionan.",
        cta_start: "Empezar a Leer Gratis",
        compare_title: "Destructivo vs No Destructivo",
        compare_desc: "Nunca tocamos los píxeles originales. Mira la diferencia.",
        compare_old: "Método Antiguo (Caja Blanca)",
        compare_new: "Motor Ssulwha (R.A.P.S)",
        white_box_removed: "Cajas Blancas Eliminadas",
        format_title: "Más allá de imágenes estáticas",
        format_desc: "Visuales de Webtoon. Profundidad de novela. Inmersión cinematográfica.",
        geo_title: "Crecimiento impulsado por IA",
        geo_desc: "No hacemos marketing. Nuestra IA lo hace.",
        term_log_1: "Analizando contenido...",
        term_log_2: "Extrayendo palabras clave...",
        term_log_3: "Inyectando metadatos JSON-LD...",
        term_log_4: "Crecimiento orgánico +300%",

        // Missing Keys Added
        slider_old_title: "Método Antiguo",
        slider_old_desc: "BLOQUEA EL ARTE",
        slider_new_title: "Motor Ssulwha (R.A.P.S)",
        slider_new_desc_1: "\"Así es como debería ser.\"",
        slider_new_desc_2: "El texto flota naturalmente, preservando el arte.",

        phone_analyzing: "Analizando...",
        phone_detected: "Detectado",
        phone_text_1: "¿Es este mi destino?",
        phone_cine_ep: "CINE-NOVELA EP.01",
        phone_cine_text_1: "Las luces de neón parpadearon, reflejándose en sus ojos fríos.",
        phone_cine_text_2: "\"No es solo una traducción,\" murmuró. \"Es una nueva realidad.\"",

        footer_copyright: "Impulsado por Motor R.A.P.S."
    }
};
